export default __webpack_public_path__ + "static/media/ayuzu.228fe723.svg";